import { defineStore } from "pinia";
import { ref } from "vue";

export default defineStore("notifications", () => {
  const notifications = ref([]);

  function addNotification(text, color = "green", removeAfter = null) {
    // color options: green, red, gray
    const id = Math.random().toString(16).slice(2);
    notifications.value.push({ id, text, color });

    if (removeAfter && removeAfter > 0) {
      setTimeout(() => {
        removeNotification(id);
      }, removeAfter);
    }
    return id;
  }

  function removeNotification(id) {
    notifications.value = notifications.value.filter((n) => n.id !== id);
  }

  return { notifications, addNotification, removeNotification };
});
